// extracted by mini-css-extract-plugin
module.exports = {"ToggleTabs":"styles_ToggleTabs__3L-9Y","ToggleTabsWrapper":"styles_ToggleTabsWrapper__1EiRE","ToggleTabsItem":"styles_ToggleTabsItem__3X69n"};